import moment from 'moment';
import { removeNonIntegers } from '../../../util/util';
import { schema } from './submissionSchema';

/* submissionTransformer.js
 *   The main function exported by this file is SubmissionTransformer
 *   which takes in (props) values from somewhere (e.g. container.js)
 *   and returns a new JavaScript object, conforming to what the backend
 *   schema expects. SubmissionTransformer is a pure function, so it will not
 *   have any (potentially harmful) side affects on the source data/props.
 *
 *   In container.js you can see that object is *again*
 *   transformed into with FormData() to also attach files.
 *
 *   TODO Once backend schema/interactions are more fixed, as many changes as
 *   possible that are made here should be "offloaded" back to the main
 *   (Formik) forms, rather than using this ad-hoc approach.
 */

const SubmissionTransformer = values => {
  // Transform submission data to match this spec
  // http://api-dev.btisinc.com/v1/agentregistration/swagger/index.html
  let submission = { ...values };

  // Make sure to trim white space; then combine fields if necessary, or just return address1 line
  const combineAddress = (add1, add2) => {
    return add2 ? `${add1.trim()} ${add2.trim()}` : add1;
  };

  submission.Address = combineAddress(
    submission.address1,
    submission.address2
  ).substring(0, 100); // Trim to less than 100 characters
  if (submission.MailingAddress1) {
    submission.MailingAddress = combineAddress(
      submission.MailingAddress1,
      submission.MailingAddress2
    ).substring(0, 100); // Trim to less than 100 characters
  } else {
    submission.MailingAddress = '';
  }
  // Address lines are combined, so deleting individual components
  delete submission.address1;
  delete submission.address2;
  delete submission.MailingAddress1;
  delete submission.MailingAddress2;

  // Data pertaining to navigating this app is not submitted to server
  delete submission.currentStep;
  delete submission.progress;
  delete submission._persist; // redux-persist var shouldn't be submitted

  // Exclude files (will be handled in container.js)
  delete submission.AgencyLicenseFile;
  delete submission.ProofOfInsuranceFile;
  delete submission.W9File;

  // Name 'TaxID' rather than 'FederalTaxId' is used on the backend
  if ('FederalTaxId' in submission) {
    // Get rid of hyphens in FederalTaxID so only digits remain
    submission['TaxID'] = removeNonIntegers(submission['FederalTaxId']);
    delete submission['FederalTaxId'];
  }
  // Reformat phone number
  submission.PhoneNumber = removeNonIntegers(submission['PhoneNumber']);

  // Reformat mobile number
  if ('MobileNumber' in submission) {
    submission.MobileNumber = removeNonIntegers(submission['MobileNumber']);
  }

  // Reformat fax number
  if ('MobileNumber' in submission) {
    submission.MobileNumber = removeNonIntegers(submission['MobileNumber']);
  }

  if ('StatementFaxNumber' in submission) {
    submission.StatementFaxNumber = removeNonIntegers(
      submission['StatementFaxNumber']
    );
  }

  submission.EOPExpDate = moment(submission.EOPExpDate)
    .format('MM/DD/YYYY');
  submission.LicenseExpDate = moment(submission.LicenseExpDate)
    .format('MM/DD/YYYY');

  submission.MonthlyStatement = 'email';

  if(submission.HowDidYouHearAboutUs === "Referral"){
    submission.HowDidYouHearAboutUs += " - " + submission.HowDidYouHearAboutUsOther;
  }

  delete submission.HowDidYouHearAboutUsOther;

  schema
    .isValid(submission)
    .then(x => {
      if (!x) {
        let casted = schema.cast(submission);
        return casted;
      }
    })
    .catch(e => {
      console.log('Something went wrong', e);
    });
  return submission;
};
export default SubmissionTransformer;
